import React from "react";
import { Card } from "react-bootstrap";
import homepic from "../../../images/homepic.jpg";
import "./Homepic.css";
const Homepic = () => {
  return (
    <div>
      <Card className="">
        <Card.Text className="card-text">
          Planning a week away with the family? Or a fun filled weekend with
          friends? Our range of camping equipment and accessories will ensure
          you are well equipped. We have a wide selection of affordable tents
          ranging from 2 man pop up tents, perfect for festivals, to spacious 6
          man family tents.
        </Card.Text>
        <Card.Img className="homepic" src={homepic} alt="Card image" />
        {/* <Card.ImgOverlay> */}
      </Card>
    </div>
  );
};

export default Homepic;
